import { useEffect, useState } from "react";
import { motion } from "framer-motion";

function computeRemaining(target) {
    const diff = target.getTime() - Date.now();
    if (diff <= 0)
        return { days: 0, hours: 0, minutes: 0, seconds: 0, done: true };

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    return { days, hours, minutes, seconds, done: false };
}

const UNITS = [
    { key: "days", label: "Giorni" },
    { key: "hours", label: "Ore" },
    { key: "minutes", label: "Minuti" },
    { key: "seconds", label: "Secondi" },
];

export default function Countdown({ target = "2026-07-02T10:00:00+02:00" }) {
    const targetDate = new Date(target);
    const [t, setT] = useState(() => computeRemaining(targetDate));

    useEffect(() => {
        const id = setInterval(() => setT(computeRemaining(targetDate)), 1000);
        return () => clearInterval(id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [target]);

    return (
        <section
            data-testid="countdown"
            className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20"
        >
            <div className="relative border border-[#2A2A2A] bg-[#0A0A0A] p-8 md:p-12 overflow-hidden">
                <div className="absolute -top-20 -left-20 w-80 h-80 rounded-full bg-[#FF4500]/15 blur-[120px]" />
                <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
                    <div className="lg:col-span-4">
                        <p className="text-xs uppercase tracking-[0.3em] text-[#CCFF00] font-bold">
                            / Tip-off
                        </p>
                        <h3 className="mt-3 font-bebas uppercase text-4xl md:text-5xl leading-[0.9]">
                            Il countdown <br />
                            <span className="text-[#FF4500]">è iniziato</span>
                        </h3>
                        <p className="mt-4 text-sm text-[#A3A3A3] leading-relaxed">
                            Tempo rimasto al fischio d'inizio del torneo, 2 Luglio
                            2026.
                        </p>
                    </div>

                    <div className="lg:col-span-8">
                        {t.done ? (
                            <p
                                data-testid="countdown-done"
                                className="font-bebas text-6xl md:text-7xl uppercase text-[#FF4500]"
                            >
                                Torneo iniziato!
                            </p>
                        ) : (
                            <div className="grid grid-cols-4 gap-3 md:gap-6">
                                {UNITS.map((u) => (
                                    <motion.div
                                        key={u.key}
                                        initial={{ opacity: 0, y: 20 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        viewport={{ once: true }}
                                        transition={{ duration: 0.4 }}
                                        data-testid={`countdown-${u.key}`}
                                        className="bg-[#050505] border border-[#2A2A2A] p-4 md:p-6 text-center hover:border-[#FF4500] transition-colors"
                                    >
                                        <span className="block font-bebas text-5xl md:text-7xl leading-none text-white tabular-nums">
                                            {String(t[u.key]).padStart(2, "0")}
                                        </span>
                                        <span className="mt-2 block text-[10px] md:text-xs uppercase tracking-[0.25em] text-[#A3A3A3] font-bold">
                                            {u.label}
                                        </span>
                                    </motion.div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}